<template>
  <v-card
    class="mx-auto rounded-card card-shadow"
    v-bind="$attrs"
  >
    <v-card-text class="text--primary" :class="emptyClass">
      <figure>
        <v-chart :options="chart"
                  ref="prazoChart"
                  theme="primary"
                  autoresize/>
      </figure>
      <v-divider/>
      <v-row dense class="mt-2">
        <v-col cols="12" sm="8">
          <span class="d-flex justify-start font-weight-bold body-2">
            PMP Geral do período
          </span>
        </v-col>
        <v-col cols="12" sm="4">
          <span class="d-flex justify-end font-weight-bold body-2">
            {{ mediaGeral }} dias
          </span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import chartMixin from '@/mixins/chart-mixin';
import { buildTimeframeChartFromObject, toEchartData } from '@/utils/chart-utils';
import IndicadoresService from './dashboard-service';

export default {
  props: {
    stringFilter: String,
    tipoProduto: String,
    cardHeight: {
      type: String,
      default: '260px',
    },
  },
  data() {
    return {
      indicadores: null,
      chart: null,
    };
  },
  mixins: [chartMixin],
  computed: {
    mediaGeral() {
      return this.indicadores?.pmpGeral || 0;
    },
    emptyClass() {
      return this.indicadores && (this.indicadores.pmpByDate || this.indicadores.pmpByDate.length) ? '' : 'dashboard-empty-div';
    },
  },
  methods: {
    showLoading() {
      this.$refs.prazoChart.showLoading(this.loadingConfig);
    },
    hideLoading() {
      if (!this.$refs.prazoChart) {
        return;
      }
      this.$refs.prazoChart.hideLoading();
    },
    buildChart() {
      const prazos = buildTimeframeChartFromObject(this.indicadores.pmpByDate, true);
      return {
        title: {
          text: 'Prazo Médio de Pagamento(PMP) Por período',
        },
        tooltip: {
          formatter: this.tooltipDayFormatter,
        },
        dataset: {
          source: [
            ['Prazos'],
            ...toEchartData(prazos, 'description', 'value'),
          ],
        },
        xAxis: {
          type: 'category',
          interval: 1,
          maxInterval: 1,
          splitNumber: 1,
        },
        yAxis: {
          axisLabel: {
            formatter: this.axisDayFormatter,
          },
        },
        grid: {
          left: '15%',
        },
        series: [{
          type: 'bar',
          seriesLayoutBy: 'column',
          realtimeSort: true,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        }],
      };
    },
    getCompras() {
      const filter = this.stringFilter;

      this.showLoading();
      IndicadoresService.getComprasPrazoMedio({
        filter,
        tipoProduto: this.tipoProduto || undefined,
      })
        .then((response) => {
          this.indicadores = response.data;
          this.chart = this.buildChart();
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
  mounted() {
    this.getCompras();
  },
  watch: {
    stringFilter(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getCompras();
    },
    tipoProduto(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getCompras();
    },
  },
};
</script>

<style scoped>
figure .echarts {
  width: 100%;
  height: 300px;
}
.dashboard-empty-div {
  width: 100%;
  height: 300px;
}
</style>
